import {useState} from "react";
import {LuWrench} from "react-icons/lu";

import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {BulkSetMaintenanceModalV2} from "@/pages/checks/list/actions/bulkSetMaintenance/BulkSetMaintenanceModalV2.tsx";

export interface BulkSetMaintenanceButtonAndModalProps {
  selectedItemsIds: number[];
  onSuccess: () => void;
}

export const BulkSetMaintenanceButtonAndModal = ({
  selectedItemsIds,
  onSuccess,
}: BulkSetMaintenanceButtonAndModalProps) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <TableCrownButton
        tooltip="Run Maintenance"
        onClick={() => {
          setShow(true);
        }}
      >
        <Icon icon={LuWrench} /> <span>Maintenance</span>
      </TableCrownButton>
      {show && (
        <BulkSetMaintenanceModalV2
          show={show}
          setShow={setShow}
          selectedItemsIds={selectedItemsIds}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
};
